import { Plugin } from "@atlassiansox/microscopekit";
import * as React from "react";
import ObservabilityNavigation from "./service/navigation/ObservabilityNavigation";
import ObservabilityApp from "./service/pages/ObservabilityApp";
// Microscope imports your plugin from here
var ObservabilityPlugin = function () {
    return (React.createElement(Plugin, { id: "observability", serviceContainer: {
            routes: [
                {
                    path: "observability",
                    component: ObservabilityApp,
                },
            ],
            navigation: [
                {
                    id: "service-navs",
                    component: ObservabilityNavigation,
                },
            ],
        } }));
};
export default ObservabilityPlugin;
